import axios from 'axios'

export default {
    listPositions: async (params) => {
        const response = await axios.get('/positions', { params })

        return response && response.data && response.data.response
    },
}
